module.exports = __webpack_public_path__ + "static/media/FIFO.f62260b6.png";